module.exports = __webpack_public_path__ + "img/swingVariabilityText1.e3674639.png";